import { ElNotification, ElMessageBox } from 'element-plus'

// 消息提示
export function notice(message, type = "success", dangerouslyUseHTMLString = true) {
  ElNotification({
    message,
    type,
    dangerouslyUseHTMLString,
    duration: type === 'error' ? 10000 : 3000  ,
    width: 500
  })
}

export function showModal(content = "提示内容", type = "warning", title = "") {
  return ElMessageBox.confirm(
    content,
    title,
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type,
      width: 500
    }
  )
}
export function removeRepeatStr(str) {
  let newStr = []
  let flag
  for (let i = 0; i < str.length; i++) {
    flag = 1
    for (let j = 0; j < newStr.length; j++) {
      if (str[i] == newStr[j]) {
        flag = 0
        break
      }
    }
    if (flag) {
      newStr.push(str[i])
    }
  }
  return newStr
}

export function isBlobStream(res, fileName) {
  let blob = res.data
  if(res.data.type=='application/json'){
    const reader  = new FileReader();  //创建一个FileReader实例
    reader.readAsText(res.data, 'utf-8'); //读取文件,结果用字符串形式表示
    reader.onload=function(){//读取完成后,**获取reader.result**
      const  {msg}  = JSON.parse(reader.result);
      notice(msg, 'error')
    }
  } else {
    //将请求的blob数据转为可下载的url地址
    let url = URL.createObjectURL(blob)

    // 创建一个下载标签<a>
    const aLink = document.createElement('a')
    aLink.href = url

    // 2.直接使用自定义文件名,设置下载文件名称
    aLink.setAttribute('download', fileName )
    document.body.appendChild(aLink)

    // 模拟点击下载
    aLink.click()

    // 移除改下载标签
    document.body.removeChild(aLink);
  }
}

export function deepCompare(obj1, obj2) {
  // 首先检查它们是否都是对象或数组，并且类型相同
  if (obj1 === obj2) {
    return true; // 如果它们引用相同的对象或都是原始值且相等
  }

  if (typeof obj1 !== 'object' || obj1 === null ||
      typeof obj2 !== 'object' || obj2 === null) {
    return false; // 如果它们不是对象或数组
  }

  // 获取对象的类型标签（数组或对象）
  let type1 = Array.isArray(obj1) ? 'array' : 'object';
  let type2 = Array.isArray(obj2) ? 'array' : 'object';

  // 如果类型不同，它们不可能相等
  if (type1 !== type2) {
    return false;
  }

  // 对于对象，比较它们的键
  let keys1 = Object.keys(obj1);
  let keys2 = Object.keys(obj2);

  // 如果键的数量不同，它们不可能相等
  if (keys1.length !== keys2.length) {
    return false;
  }

  // 检查每个键是否存在于另一个对象中，并且值相等
  for (let key of keys1) {
    if (!keys2.includes(key) || !deepCompare(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true; // 如果所有检查都通过，则它们是相等的
}